import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const ALLIES_ROUTES: RouteObject[] = [
  {
    path: 'allies',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'allies',
        lazy: async () => {
          const AlliesPage = lazy(
            () => import('@/pages/allies/allies/AlliesPage.tsx')
          )
          return { element: <AlliesPage /> }
        }
      },
      {
        path: 'allies/:id',
        lazy: async () => {
          const AlliesDetailsPage = lazy(
            () => import('@/pages/allies/allyDetails/AlliesDetailsPage.tsx')
          )
          return { element: <AlliesDetailsPage /> }
        }
      },
      {
        path: 'allies/:id/details/:allyId',
        lazy: async () => {
          const SaleDetailsPage = lazy(
            () => import('@/pages/saleDetails/SaleDetails.tsx')
          )
          return { element: <SaleDetailsPage /> }
        }
      },
      {
        path: 'allies/:id/collections/:allyId',
        lazy: async () => {
          const DailyCollectionsPage = lazy(
            () => import('@/pages/dailyCollections/DailyCollections.tsx')
          )
          return { element: <DailyCollectionsPage /> }
        }
      },
      {
        path: 'allies/:id/others/:allyId',
        lazy: async () => {
          const OtherOperationsPage = lazy(
            () => import('@/pages/otherOperations/OtherOperations.tsx')
          )
          return { element: <OtherOperationsPage /> }
        }
      },
      {
        path: 'allies/:id/wallet',
        lazy: async () => {
          const AllyWalletPage = lazy(
            () => import('@/pages/allies/allyWallet/AllyWalletPage.tsx')
          )
          return { element: <AllyWalletPage /> }
        }
      },
      {
        path: 'payment-request',
        lazy: async () => {
          const PaymentRequestPage = lazy(
            () => import('@/pages/paymentRequests/PaymentRequestPage.tsx')
          )
          return { element: <PaymentRequestPage /> }
        }
      },
      {
        path: 'daily-cut',
        lazy: async () => {
          const DailyCutCollectionsPage = lazy(
            () => import('@/pages/dailyCut/DailyCutCollectionPage.tsx')
          )
          return { element: <DailyCutCollectionsPage /> }
        }
      },
      {
        path: 'daily-cut/details/:allyId',
        lazy: async () => {
          const SaleDetailsPage = lazy(
            () => import('@/pages/saleDetails/SaleDetails.tsx')
          )
          return { element: <SaleDetailsPage /> }
        }
      },
      {
        path: 'daily-cut/collections/:allyId',
        lazy: async () => {
          const DailyCollectionsPage = lazy(
            () => import('@/pages/dailyCollections/DailyCollections.tsx')
          )
          return { element: <DailyCollectionsPage /> }
        }
      },
      {
        path: 'daily-cut/others/:allyId',
        lazy: async () => {
          const OtherOperationsPage = lazy(
            () => import('@/pages/otherOperations/OtherOperations.tsx')
          )
          return { element: <OtherOperationsPage /> }
        }
      },
      {
        path: 'monthly-cut',
        lazy: async () => {
          const MonthlyCutPage = lazy(
            () => import('@/pages/monthlyCut/MonthlyCutPage.tsx')
          )
          return { element: <MonthlyCutPage /> }
        }
      }
    ]
  }
]

export default ALLIES_ROUTES
